import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { serverUtilities } from "services/serverutilities.service";
import { useHistory } from 'react-router-dom';
const SubjectView = () => {
   const history = useHistory();    
  const location = useLocation();
  const { id, courseName } = location.state || {};
  const [courseContent, setCourseContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseContent = async () => {
      try {
        const apiData = await serverUtilities.getCourseContent(id,'0');
        setCourseContent(apiData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching course content:', error);
        setLoading(false);
      }
    };
    
    fetchCourseContent();
  }, [id]);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!courseContent) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>No course content available</div>;
  }

  const { buckets } = courseContent;

   const gotochaptercontent = (id, image) => {
    console.log('Navigate to course:', id);
      //  history.push(`/subject/${id}`);
      history.push({
  pathname: `/content/${id}`,
  state: { id}
});
   }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ color: '#333', marginBottom: '30px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
        {courseName || 'Course Content'}
      </h1>
      
      <div style={{ marginBottom: '40px' }}>
        {/* <h2 style={{ color: '#444', marginBottom: '15px' }}>Buckets</h2> */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          {Object.keys(buckets).map(bucketId => {
            const bucket = buckets[bucketId];
            return (
              <div 
                key={bucketId}
                style={{
                  flex: '1 1 300px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  padding: '15px',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                  backgroundColor: '#fff'
                }}
              >
                <h3 style={{ 
                  color: '#2c3e50', 
                  marginTop: '0',
                  paddingBottom: '10px',
                  borderBottom: '1px solid #eee'
                }}>
                  {bucket.bucket_name}
                </h3>
                {/* <div style={{ marginTop: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                    <span style={{ fontWeight: 'bold' }}>Videos:</span>
                    <span>{bucket.bucket_total_videos}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                    <span style={{ fontWeight: 'bold' }}>Tests:</span>
                    <span>{bucket.bucket_total_tests}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                    <span style={{ fontWeight: 'bold' }}>E-books:</span>
                    <span>{bucket.bucket_total_ebooks}</span>
                  </div>
                </div> */}
                
                {/* Groups within the bucket */}
                <div style={{ marginTop: '20px' }}>
                  {/* <h4 style={{ 
                    color: '#34495e', 
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}>
                    Groups
                  </h4> */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    {Object.keys(bucket.groups).map(groupId => {
                      const group = bucket.groups[groupId];
                      return (
                        <div 
                          key={groupId}
                          style={{
                            border: '1px solid #eee',
                            borderRadius: '6px',
                            padding: '10px',
                            backgroundColor: '#f9f9f9'
                          }}
                          onClick={()=>gotochaptercontent(groupId)}
                        >
                          <div style={{ 
                            fontWeight: 'bold', 
                            color: '#2980b9',
                            marginBottom: '5px'
                          }}>
                            {group.group_name}
                          </div>
                          <div style={{ fontSize: '14px', color: '#555' }}>
                            {/* <div>Priority: {group.priority}</div> */}
                            {group.content_json && (
                              <div>Items: {group.content_json.length}</div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SubjectView;